import * as React from 'react';

import DeliverableSubHeader from '../../deliverable-sub-header/DeliverableSubHeader';
import DeliverableMediaAttachmentsForDeliverable from '../../../media/parts/DeliverableMediaAttachmentsForDeliverable';
import DeliverableAttachmentUploader from '../../deliverable-attachment-uploader/DeliverableAttachmentUploader';

import { DELIVERABLE_ATTACHMENT_TYPE_CONTENT, DELIVERABLE_TYPE_ZALANDO_OUTFIT } from 'utils/deliverables';
import { __t, applyTranslations } from 'utils/language';

import {
  Deliverable,
  DeliverableAttachment,
  DeliverableAttachmentApprovalStatus,
  Subcampaign
} from 'types';

applyTranslations(require('./deliverable-content-for-approval.i18n.json'));

type Props = {
  isEditMode: boolean,
  isForBrand?: boolean,
  subcampaign: Subcampaign,
  deliverable: Deliverable,
  attachments: Array<DeliverableAttachment>,
  allowContentMove?: boolean,
  onApprovalStatusChanged: (deliverableAttachment: DeliverableAttachment, approvalStatus: DeliverableAttachmentApprovalStatus) => void,
  onOpenMoveContent: (showMoveContent: boolean) => void,
  onEditMode: (isEditMode: boolean) => void,
  onUpdate: (tempAttachments: Array<DeliverableAttachment>) => void,
  onResetApprovalStatus: (deliverableAttachment: Array<DeliverableAttachment>) => void,
  onDeleteAttachments?: (deliverableAttachment: Array<DeliverableAttachment>) => void,
  onOpenClientApproval: (openClientApproval?: boolean) => void,
  onApplyClientFeedback?: (deliverable: Deliverable, attachmentId?: number | null) => void
}

const msgKey = 'deliverable_content_for_approval';

const DeliverableContentForApproval = ({
  isEditMode,
  isForBrand,
  subcampaign,
  attachments = [],
  deliverable,
  allowContentMove,
  onDeleteAttachments,
  onOpenMoveContent,
  onResetApprovalStatus,
  onApprovalStatusChanged,
  onOpenClientApproval,
  onEditMode,
  onApplyClientFeedback,
  onUpdate }: Props) => {
  const isNonEditableEmptyMode = !(isEditMode || attachments.length || !isForBrand);
  const isZalandoOutfit = deliverable.deliverableType === DELIVERABLE_TYPE_ZALANDO_OUTFIT;
  const instructionKeyBrand = isZalandoOutfit ? 'brand.outfits' : 'brand.content';
  const instruction = isNonEditableEmptyMode
    ? ''
    : __t(`${msgKey}.upload_instruction.${isForBrand ? instructionKeyBrand : 'influencer'}`);

  return (
    <React.Fragment>
      <DeliverableSubHeader
        title={__t(`${msgKey}.labels.${isZalandoOutfit ? 'outfits' : 'content'}`)}
        instruction={instruction}
        directon={isNonEditableEmptyMode ? 'row' : 'column'}
        emptyNote={isNonEditableEmptyMode ? __t(`${msgKey}.content_empty_note`) : ''}
      />
      {
      !isNonEditableEmptyMode && (
        <DeliverableMediaAttachmentsForDeliverable
          isNewDeliverable
          canApprove={!!isForBrand && !isEditMode}
          canUpload={isEditMode || !isForBrand}
          subcampaign={subcampaign}
          deliverable={deliverable}
          attachments={attachments}
          allowContentMove={allowContentMove}
          placeholderForUpload={(
            <DeliverableAttachmentUploader
              size="big"
              deliverable={deliverable}
              attachmentType={DELIVERABLE_ATTACHMENT_TYPE_CONTENT}
              onUpdate={onUpdate}
            />
          )}
          onOpenMoveContent={onOpenMoveContent}
          onApprovalStatusChanged={onApprovalStatusChanged}
          onEditMode={() => onEditMode(!isEditMode)}
          onResetApprovalStatus={onResetApprovalStatus}
          onDeleteAttachments={onDeleteAttachments}
          onOpenClientApproval={onOpenClientApproval}
          onApplyClientFeedback={onApplyClientFeedback}
        />
      )
    }
    </React.Fragment>
  );
};

export default DeliverableContentForApproval;
